import { Table } from 'react-bootstrap';
import DashboardHeader from '../../Components/DashboardHeader/DashboardHeader';
import TransactionTable from '../../Components/TransactionTable/TransactionTable';
import './Transactions.css';

const Transactions = () => {
  return (
    <div className="transactions-container">
      <DashboardHeader title="Transaction History" />
      <TransactionTable />
    </div>
  );
}

export default Transactions;